import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogTitle,
} from "@angular/material/dialog";
import { MatButton, MatIconButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { ContentDataViewerComponent } from "../content-data-viewer/content-data-viewer.component";
import type { DataResult } from "../../../../model/data.types";

export interface DataDetailDialogData {
  data: DataResult;
  /** Dialog header title. Defaults to the data type. */
  title?: string;
}

/**
 * Full-screen dialog for viewing a DataResult without inline size constraints.
 * Opened by the view_data action from ContentActionBarComponent.
 */
@Component({
  selector: "app-data-detail-dialog",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogTitle,
    MatButton,
    MatIconButton,
    MatIcon,
    ContentDataViewerComponent,
  ],
  templateUrl: "./data-detail-dialog.component.html",
  styleUrl: "./data-detail-dialog.component.scss",
})
export class DataDetailDialogComponent {
  protected readonly dialogData = inject<DataDetailDialogData>(MAT_DIALOG_DATA);
}
